import React from "react";

import styles from "./styles/MyAccount.module.css"
import { useEffect } from "react";

function MobPopUp({children, OnBack}){
    useEffect(() => {
        document.documentElement.style.overflow = "hidden";
        return () => {
            document.documentElement.style.overflow = "unset";
        };
    }, []);
    return (
        <div className={styles.pop_upbackground}>            
            <div onClick={(e)=>{e.stopPropagation()}} className={styles.popup_main}>
                <div onClick={()=>OnBack()} className={styles.back_button}>
                    <div  className={styles.back_logo}/>
                    <div style={{cursor:"pointer"}}>Back</div>
                </div>

                {children}
            </div>
        </div>
    )

}
export {MobPopUp};